import { Link } from "react-router-dom";

const NAV = [
  { name: "The Opportunity", path: "/opportunity" },
  { name: "Technology", path: "/technology" },
  { name: "Intellectual Property", path: "/intellectual-property" },
  { name: "Partnering & Supply", path: "/partnering" },
  { name: "About & Contact", path: "/about-contact" },
];

export const Footer = () => (
  <footer className="bg-obsidian text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
      <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 bg-white flex items-center justify-center p-1">
              <img src="/logo-transparent.png" alt="Chocolate Detox logo" className="w-full h-full object-contain" />
            </span>
            <span className="font-headline font-semibold tracking-tight text-lg">CHOCOLATE DETOX LLC</span>
          </div>
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-sm">
            Developer and sole-source supplier of a proprietary mineral adsorbent active
            for use in veterinary products intended for canine methylxanthine (chocolate) toxicosis.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Navigate</p>
          <ul className="space-y-2.5">
            {NAV.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-sm text-white/70 hover:text-white transition-colors duration-200">
                  {l.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Contact</p>
          <p className="text-sm text-white/70">Madison, Wisconsin, USA</p>
          <a
            href="mailto:amadeus@chocolatedetoxfordogs.com"
            data-testid="footer-email-link"
            className="text-sm text-pinelight hover:text-white transition-colors duration-200 mt-2 inline-block"
          >
            amadeus@chocolatedetoxfordogs.com
          </a>
        </div>
      </div>

      <div className="py-8 border-b border-white/10">
        <p
          data-testid="footer-compliance-disclaimer"
          className="text-[12px] leading-relaxed text-white/50 border-l-2 border-pine pl-4 max-w-4xl"
        >
          Information provided for business evaluation by manufacturers and licensees. Not a medical
          claim. Products containing this ingredient are subject to regulatory approval in each market.
        </p>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
          © 2026 Chocolate Detox LLC · Madison, Wisconsin
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
          B2B ingredient supply only · no consumer sales
        </p>
      </div>
    </div>
  </footer>
);
